import { Box, Button, Grid, Typography, makeStyles } from "@material-ui/core";
import {
  FilterList,
  CalendarToday,
  Timeline,
  GetApp,
} from "@mui/icons-material";
import themeColorsDesingSystem from "assets/theme/ds-colors";

const useStyles = makeStyles({
  wrapper: {
    backgroundColor: themeColorsDesingSystem.background.main,
    padding: "0.75rem 1rem",
    borderRadius: 4,
    boxShadow: "0 1px 3px rgba(0,0,0,0.08)",
    border: `1px solid ${themeColorsDesingSystem.stone.main}`,
    marginBottom: "1.5rem",
    marginTop: "1.5rem",
  },
  title: {
    display: "flex",
    alignItems: "center",
    gap: 8,
    fontSize: "0.875rem",
    fontWeight: 600,
    color: themeColorsDesingSystem.gray.dark,
  },
  dateInputWrapper: {
    display: "flex",
    alignItems: "center",
    gap: 8,
    backgroundColor: "#f8fafc",
    border: `1px solid ${themeColorsDesingSystem.stone.main}`,
    borderRadius: 4,
    padding: "4px 8px",
    height: 32,
  },
  nativeDateInput: {
    background: "transparent",
    border: "none",
    outline: "none",
    fontSize: "0.75rem",
    color: themeColorsDesingSystem.gray.dark,
    fontFamily: "inherit",
    lineHeight: 1.5,
    minWidth: 120,
    cursor: "pointer",
    "&::-webkit-calendar-picker-indicator": {
      cursor: "pointer",
      opacity: 0.5,
    },
  },
  applyButton: {
    backgroundColor: themeColorsDesingSystem.primary.main,
    color: themeColorsDesingSystem.background.main,
    fontSize: "0.75rem",
    fontWeight: 500,
    padding: "6px 12px",
    textTransform: "none",
    minHeight: 32,
    "&:hover": {
      backgroundColor: themeColorsDesingSystem.primary.active,
    },
  },
  secondaryButton: {
    fontSize: "0.75rem",
    fontWeight: 600,
    textTransform: "none",
    padding: "6px 12px",
    minHeight: 32,
  },
  historyButton: {
    backgroundColor: themeColorsDesingSystem.secondary.active,
    color: themeColorsDesingSystem.primary.main,
    border: `1px solid ${themeColorsDesingSystem.secondary.main}`,
  },
  exportButton: {
    backgroundColor: themeColorsDesingSystem.green.background,
    color: themeColorsDesingSystem.green.main,
    border: `1px solid ${themeColorsDesingSystem.green.backgroundActive}`,
  },
  divider: {
    width: 1,
    height: 24,
    backgroundColor: themeColorsDesingSystem.stone.medium,
    margin: "0 4px",
    display: "none",
    "@media (min-width: 600px)": {
      display: "block",
    },
  },
});

export default function GlobalPeriodFilter({
  startDate,
  endDate,
  onStartDateChange,
  onEndDateChange,
  onApply,
  onOpenHistory,
  onExport,
}) {
  const classes = useStyles();

  return (
    <Box className={classes.wrapper}>
      <Grid container alignItems="center" justify="space-between" spacing={2}>
        <Grid item xs={12} sm="auto">
          <Typography className={classes.title}>
            <FilterList
              fontSize="small"
              style={{ color: themeColorsDesingSystem.primary.main }}
            />
            Filtro de Período Global
          </Typography>
        </Grid>

        <Grid item xs={12} sm="auto">
          <Box
            display="flex"
            flexWrap="wrap"
            alignItems="center"
            style={{ gap: 12 }}
          >
            <Box className={classes.dateInputWrapper}>
              <CalendarToday
                style={{
                  fontSize: 14,
                  color: themeColorsDesingSystem.gray.main,
                  flexShrink: 0,
                }}
              />
              <input
                type="date"
                value={startDate}
                onChange={(e) => onStartDateChange(e.target.value)}
                className={classes.nativeDateInput}
              />
            </Box>

            <Typography
              variant="caption"
              style={{ color: themeColorsDesingSystem.gray.main }}
            >
              até
            </Typography>

            <Box className={classes.dateInputWrapper}>
              <CalendarToday
                style={{
                  fontSize: 14,
                  color: themeColorsDesingSystem.gray.main,
                  flexShrink: 0,
                }}
              />
              <input
                type="date"
                value={endDate}
                onChange={(e) => onEndDateChange(e.target.value)}
                className={classes.nativeDateInput}
              />
            </Box>

            <Button
              className={classes.applyButton}
              variant="contained"
              disableElevation
              onClick={onApply}
            >
              Aplicar
            </Button>

            <Box className={classes.divider} />

            <Button
              className={`${classes.secondaryButton} ${classes.historyButton}`}
              variant="outlined"
              startIcon={<Timeline style={{ fontSize: 14 }} />}
              style={{
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
              }}
              onClick={onOpenHistory}
            >
              Histórico Detalhado
            </Button>

            <Button
              className={`${classes.secondaryButton} ${classes.exportButton}`}
              variant="outlined"
              startIcon={<GetApp style={{ fontSize: 14 }} />}
              style={{
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
              }}
              onClick={onExport}
            >
              Exportar
            </Button>
          </Box>
        </Grid>
      </Grid>
    </Box>
  );
}
